/* eslint-disable no-unused-vars */
import api from '@utils/api'

import { mergeDigitalFormToFinalLayout } from '@utils/general'

import { SET_VALUES_DIGITAL_FORM } from '@constants/actionType'
import { LANGUAGE_DEFAULT, MAIN_CLASS_HTML_DIGITAL_FORM } from '@constants/general';

export const getDigitalForms = () => async (dispatch, _getState) => {
  const response = await api.getDigitalForms()
  // const response = {
  //   data: [
  //     {
  //       id: 1,
  //       nombre: "Anexo A. Cuestionario de Recopilación de Datos para una Debida Diligencia",
  //       archivo: "Anexo A. Cuestionario de Recopilación de Datos para una Debida Diligencia",
  //       procesoId: 1,
  //       nombreProceso: "Debida Diligencia Reducido",
  //       grupo: 1,
  //       defaultVersion: 1
  //     },
  //     {
  //       id: 2,
  //       nombre: "Anexo A.1. Cuestionario para la Determinación del Nivel de Riesgo del Tercero en materia Anticorrupción",
  //       archivo: "Anexo A.1. Cuestionario para la Determinación del Nivel de Riesgo del Tercero en materia Anticorrupción",
  //       procesoId: 1,
  //       nombreProceso: "Debida Diligencia Reducido",
  //       grupo: 1,
  //       defaultVersion: 1
  //     },
  //     {
  //       id: 3,
  //       nombre: "Anexo A - Política Regalos Gastos de Entretenimiento y Hospitalidad (Solicitud de Regalos y Gastos de Entretenimiento)",
  //       archivo: "Anexo A - Política Regalos Gastos de Entretenimiento y Hospitalidad (Solicitud de Regalos y Gastos de Entretenimiento)",
  //       procesoId: 4,
  //       nombreProceso: "Regalos y Gastos de Entretenimiento",
  //       grupo: null,
  //       defaultVersion: 1
  //     },
  //     {
  //       id: 4,
  //       nombre: "Anexo B - Política Regalos Gastos de Entretenimiento y Hospitalidad (Solicitud Gastos de Hospitalidad)",
  //       archivo: "Anexo B - Política Regalos Gastos de Entretenimiento y Hospitalidad (Solicitud Gastos de Hospitalidad)",
  //       procesoId: 3,
  //       nombreProceso: "Gastos de Hospitalidad",
  //       grupo: null,
  //       defaultVersion: 1
  //     },
  //     {
  //       id: 5,
  //       nombre: "Anexo D - Política Regalos Gastos de Entretenimiento y Hospitalidad (Formato Carta Devolución Regalos)",
  //       archivo: "Anexo D - Política Regalos Gastos de Entretenimiento y Hospitalidad (Formato Carta Devolución Regalos)",
  //       procesoId: 2,
  //       nombreProceso: "Devolución de Regalos",
  //       grupo: null,
  //       defaultVersion: 1
  //     },
  //     {
  //       id: 6,
  //       nombre: "Anexo A. Cuestionario de Recopilación de Datos para una Debida Diligencia",
  //       archivo: "Anexo A. Cuestionario de Recopilación de Datos para una Debida Diligencia",
  //       procesoId: 5,
  //       nombreProceso: "Debida Diligencia Completo",
  //       grupo: null,
  //       defaultVersion: 1
  //     },
  //   ]
  // }
  return response
}

export const setDetailDigitalForm = ({id, nombre, archivo, id_anexo, version, estatus, plantilla = "", versiones = []}) => async (dispatch, getState) => {
  const { catalogs } = getState()
  const keysLenguages = catalogs.keysLanguageCatalog

  const general = keysLenguages.reduce((accum, language) => {
    const getPlantilla = plantilla && (plantilla[language] || plantilla[LANGUAGE_DEFAULT])
    ? decodeURIComponent(escape(window.atob(plantilla[language] || plantilla[LANGUAGE_DEFAULT])))
    : ''

    const temp = document.createElement('div');
    temp.innerHTML = getPlantilla;
    const getMainElement = temp.getElementsByClassName(MAIN_CLASS_HTML_DIGITAL_FORM)[0]

    accum[language] = { plantilla: getMainElement.outerHTML }
    return accum
  }, {})

  dispatch({
    type: SET_VALUES_DIGITAL_FORM,
    payload: {
      general: {
        nombre,
        archivo,
        ...general,
      },
      idFormulario: id,
      idAnexo: id_anexo,
      version,
      estatus,
      versiones
    },
  });



}

export const getDetailDigitalForm = ({id}) => async (dispatch, getState) => {
  const response = await api.getDetailDigitalForm(id)
  if (!response?.status) await dispatch(setDetailDigitalForm(response.data))

  return response
}


export const updateDigitalForm= (isLanding = true) => async (_dispatch, getState) => {
  const { general, idFormulario, version } = getState().digitalForm
  const { keysLanguageCatalog } = getState().catalogs

  const data = {
    id: idFormulario,
    version,
    plantilla: {},
  }

  await keysLanguageCatalog.map(item => {
    const formattingHtml = mergeDigitalFormToFinalLayout(general[item].plantilla)
    const encodedEmail = window.btoa(unescape(encodeURIComponent(formattingHtml)))
    data.plantilla[item] = encodedEmail
    // atob(encoded) // Decodificar base 64
    return true
  })

  const response = await api.editDigitalForm(data)

  return response;
};

export const updateStatusDigitalForm = ({id, status}) => async (dispatch, getState) => {
  const data = {
    status
  }
  const response = await api.updateStatusDigitalForm(id, data)
  return response
}